import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { useCompanyInfo } from '../lib/cms';
import { imageUrl } from '../lib/images';

export default function ReferencerPage() {
  const companyInfo = useCompanyInfo();
  const [activeCategory, setActiveCategory] = useState('Alle');
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const referenceItems = [
    { src: "/_assets/industrihegn-01.webp", category: "Industrihegn", title: "Industrihegn ved teknisk anlæg" },
    { src: "/_assets/industrihegn-02.webp", category: "Industrihegn", title: "Industrihegn og adgangsport" },
    { src: "/_assets/industrihegn-03.webp", category: "Industrihegn", title: "Langt galvaniseret industrihegn" },
    { src: "/_assets/industrihegn-04.webp", category: "Industrihegn", title: "Industrihegn langs vej" },
    { src: "/_assets/industrihegn-05.webp", category: "Industrihegn", title: "Facademonteret industrihegn" },
    { src: "/_assets/industrihegn-06.webp", category: "Industrihegn", title: "Bred industridobbeltport" },

    { src: "/_assets/dobbeltport-01.webp", category: "Dobbeltporte", title: "Galvaniseret dobbeltport ved erhverv" },
    { src: "/_assets/dobbeltport-02.webp", category: "Dobbeltporte", title: "Dobbeltport med gitterfyldning" },
    { src: "/_assets/dobbeltport-03.webp", category: "Dobbeltporte", title: "Mørkegrå port med geometriske felter" },

    { src: "/_assets/glashegn.webp", category: "Terrasser", title: "Terrasse med glasafskærmning" },
    { src: "/_assets/udestue.webp", category: "Terrasser", title: "Udestue og overdækket terrasse" },

    { src: "/_assets/betonhegn-01.webp", category: "Betonhegn", title: "Træstruktureret betonhegn" },
    { src: "/_assets/betonhegn-02.webp", category: "Betonhegn", title: "Langstrakt betonhegn ved have" },
    { src: "/_assets/snapchat-577785138.jpg", category: "Betonhegn", title: "Betonhegn" },
    { src: "/_assets/thumbnail-1000003477-0.jpg", category: "Betonhegn", title: "Betonhegn" },
    { src: "/_assets/thumbnail-img-2220-0.jpg", category: "Betonhegn", title: "Betonhegn" },
    { src: "/_assets/thumbnail-img20241211091638.jpg", category: "Betonhegn", title: "Betonhegn" },
    { src: "/_assets/thumbnail-img20250423152706.jpg", category: "Betonhegn", title: "Betonhegn" },

    { src: "/_assets/img-20220901-115952-logo.jpg", category: "Vinduespartier", title: "Vinduespartier" },
    { src: "/_assets/img-20220901-151707-logo.jpg", category: "Vinduespartier", title: "Vinduespartier" },
    { src: "/_assets/img-20240412-161321-logo-0.jpg", category: "Vinduespartier", title: "Vinduespartier" },

    { src: "/_assets/fb-img-1760014068393.jpg", category: "Træbeklædte låger", title: "Træbeklædte låger" },
    { src: "/_assets/thumbnail-img20250926084028.jpg", category: "Træbeklædte låger", title: "Træbeklædte låger" },
    { src: "/_assets/thumbnail-img20250926084045-0.jpg", category: "Træbeklædte låger", title: "Træbeklædte låger" },

    { src: "/_assets/fb-img-1760014060550.jpg", category: "Træbeklædt hegn", title: "Træbeklædt hegn" },
    { src: "/_assets/fb-img-1760014086552-0.jpg", category: "Træbeklædt hegn", title: "Træbeklædt hegn" },

    { src: "/_assets/295322415-584214203079039-442631182103604215-n-0.jpg", category: "Skur", title: "Skur" },
    { src: "/_assets/thumbnail-1000004142-0.jpg", category: "Skur", title: "Skur" },
    { src: "/_assets/thumbnail-1000004145-0_fe8d348a.jpg", category: "Skur", title: "Skur" },
    { src: "/_assets/thumbnail-img20250813095918-0.jpg", category: "Skur", title: "Skur" },
    { src: "/_assets/thumbnail-img20250813100319-0.jpg", category: "Skur", title: "Skur" },
    { src: "/_assets/thumbnail-img20250813100327-0.jpg", category: "Skur", title: "Skur" },

    { src: "/_assets/thumbnail-img20250417120146.jpg", category: "Foldeporte", title: "Foldeport" },
    { src: "/_assets/thumbnail-img20250512145254.jpg", category: "Foldeporte", title: "Foldeport" },
    { src: "/_assets/thumbnail-img20250512145308_93c3efd6.jpg", category: "Foldeporte", title: "Foldeport" },

    { src: "/_assets/thumbnail-img20250328120707.jpg", category: "Skydeporte", title: "Skydeport" },
    { src: "/_assets/thumbnail-img20250423152611.jpg", category: "Skydeporte", title: "Skydeport" },
    { src: "/_assets/thumbnail-img20250509110537.jpg", category: "Skydeporte", title: "Skydeport" },
    { src: "/_assets/thumbnail-img20250908110905.jpg", category: "Skydeporte", title: "Skydeport" },
    { src: "/_assets/thumbnail-img20250908110929.jpg", category: "Skydeporte", title: "Skydeport" },

    { src: "/_assets/307856433-619479086206962-5755407830602206550-n.jpg", category: "Rionetlåge", title: "Rionetlåge" },
    { src: "/_assets/rionet-19.jpeg", category: "Rionetlåge", title: "Rionetlåge" },
    { src: "/_assets/smedl-ge2-1.jpeg", category: "Rionetlåge", title: "Rionetlåge" },

    { src: "/_assets/333571161-1143977852939452-4405149958717881853-n-2.jpg", category: "Panellåge", title: "Panellåge" },
    { src: "/_assets/thumbnail-1000003507.jpg", category: "Panellåge", title: "Panellåge" },
    { src: "/_assets/thumbnail-1000003516.jpg", category: "Panellåge", title: "Panellåge" },
    { src: "/_assets/thumbnail-img20240508122959.jpg", category: "Panellåge", title: "Panellåge" },
    { src: "/_assets/thumbnail-img20250430120431.jpg", category: "Panellåge", title: "Panellåge" },

    { src: "/_assets/285327761-550001316500328-211016002518253666-n.jpg", category: "Smedejernshegn", title: "Smedejernshegn" },
    { src: "/_assets/285582236-550001266500333-8021079231710675885-n.jpg", category: "Smedejernshegn", title: "Smedejernshegn pris" },
    { src: "/_assets/smedejernshegn.jpg", category: "Smedejernshegn", title: "Smedejernshegn og låger" },
    { src: "/_assets/smedejernshegn-og-l-ger.jpg", category: "Smedejernshegn", title: "Smedejernshegn i Danmark" },
    { src: "/_assets/smedejernshegn-pris.jpg", category: "Smedejernshegn", title: "smedejernslåge til indkørsel" },

    { src: "/_assets/480015480-1282476033240594-6954968780598279616-n.jpg", category: "Kompositlåge", title: "kompositlåge" },
    { src: "/_assets/472310234-1121723912661396-3762314424514631135-n.jpg", category: "Kompositlåge", title: "kompositlåge i Danmark" },
    { src: "/_assets/472038870-1118953512938436-7608909420930405236-n.jpg", category: "Kompositlåge", title: "kompositlåge med håndtag" },
    { src: "/_assets/331549583-1582118552290587-2785698352397863311-n.jpg", category: "Kompositlåge", title: "kompositlåge i haven" },
    { src: "/_assets/299939634-600610274772765-4419569559744351444-n.jpg", category: "Kompositlåge", title: "kompositlåge og hegn" },
    { src: "/_assets/1000003614.jpg", category: "Kompositlåge", title: "kompositlåge ved hus" },
    { src: "/_assets/thumbnail-1000003003.jpg", category: "Kompositlåge", title: "lav kompositlåge" },
    { src: "/_assets/thumbnail-1000003390.jpg", category: "Kompositlåge", title: "kompositlåge i Odense" },
    { src: "/_assets/thumbnail-1000003442.jpg", category: "Kompositlåge", title: "kompositlåge afskærmning" },
    { src: "/_assets/thumbnail-img20241015151127.jpg", category: "Kompositlåge", title: "stor kompositlåge" },
    { src: "/_assets/thumbnail-img20241122121947.jpg", category: "Kompositlåge", title: "bred kompositlåge" },
    { src: "/_assets/thumbnail-img20250825122425.jpg", category: "Kompositlåge", title: "sort kompositlåge" },
    { src: "/_assets/316801948-679177383570465-3757897963065229175-n.jpg", category: "Kompositlåge", title: "kompositlåge i Gentofte" },
    { src: "/_assets/thumbnail-1000003446.jpg", category: "Kompositlåge", title: "kompositlåge i Silkeborg" },
    { src: "/_assets/thumbnail-1000004103.jpg", category: "Kompositlåge", title: "Kompositlåge i Aalborg" },

    { src: "/_assets/smedlge3-2.jpeg", category: "Smedejernslåge", title: "Smedejernslåge i Odense" },
    { src: "/_assets/smedlge1-1.jpeg", category: "Smedejernslåge", title: "Smedejernslåge i Danmark" },
    { src: "/_assets/smedlge4-2.jpeg", category: "Smedejernslåge", title: "Smedejernslåge" },
    { src: "/_assets/thumbnail-1000002800.jpg", category: "Smedejernslåge", title: "Smedejernslåge på mål" },
    { src: "/_assets/thumbnail-img20250716165143_580c8013.jpg", category: "Smedejernslåge", title: "smedejernslåge til indkørsel" },

    { src: "/_assets/480220622-1283354609819403-454519828912243296-n-0.jpg", category: "Rionet", title: "Rionet" },
    { src: "/_assets/rio3.jpeg", category: "Rionet", title: "Rionet" },
    { src: "/_assets/rionet-6.jpeg", category: "Rionet", title: "Rionet" },
    { src: "/_assets/315981588-673995694088634-4081471569169952651-n.jpg", category: "Rionet", title: "Rionet" },

    { src: "/_assets/490153135-1329555835199280-767963427889470727-n-0.jpg", category: "Panelhegn", title: "Panelhegn" },
    { src: "/_assets/panelhegn2.jpeg", category: "Panelhegn", title: "Panelhegn sort" },
    { src: "/_assets/panelhegn5-1.jpeg", category: "Panelhegn", title: "Panelhegn i have" },
    { src: "/_assets/panelhegn4-1.jpeg", category: "Panelhegn", title: "Panelhegn i Odense" },
    { src: "/_assets/panelhegn3.jpeg", category: "Panelhegn", title: "Panelhegn i Danmark" },
    { src: "/_assets/327032265-938137584260657-5283060228493626441-n.jpg", category: "Panelhegn", title: "Panelhegn i Aalborg" },
    { src: "/_assets/333571161-1143977852939452-4405149958717881853-n.jpg", category: "Panelhegn", title: "Panelhegn i Gentofte" },
    { src: "/_assets/thumbnail-1000003866.jpg", category: "Panelhegn", title: "Panelhegn erhverv" },
    { src: "/_assets/thumbnail-1000003902.jpg", category: "Panelhegn", title: "Panelhegn virksomheder" },
    { src: "/_assets/thumbnail-1000003903.jpg", category: "Panelhegn", title: "Panelhegn virksomhed" },
    { src: "/_assets/thumbnail-img20250219132431.jpg", category: "Panelhegn", title: "Panelhegn" },
    { src: "/_assets/1000003297.jpg", category: "Panelhegn", title: "Panelhegn" },
    { src: "/_assets/thumbnail-1000003459.jpg", category: "Panelhegn", title: "Panelhegn Hovendals" },
    { src: "/_assets/thumbnail-1000003512.jpg", category: "Panelhegn", title: "Panelhegn på landet" },

    { src: "/_assets/295322415-584214203079039-442631182103604215-n.jpg", category: "Carport", title: "Carport med indgang" },
    { src: "/_assets/thumbnail-1000004142.jpg", category: "Carport", title: "Carport affaldssortering" },
    { src: "/_assets/thumbnail-1000004145.jpg", category: "Carport", title: "Carport med skur" },
    { src: "/_assets/thumbnail-img20250813095918.jpg", category: "Carport", title: "Carport i komposit" },
    { src: "/_assets/thumbnail-img20250813100319.jpg", category: "Carport", title: "Carport i Odense" },
    { src: "/_assets/thumbnail-img20250813100327_0b99b509.jpg", category: "Carport", title: "Carport i Danmark" },
    { src: "/_assets/thumbnail-1000003547.jpg", category: "Carport", title: "Carport" },
    { src: "/_assets/thumbnail-1000006619.jpg", category: "Carport", title: "Carport" },
    { src: "/_assets/6059.jpg", category: "Carport", title: "Carport" },

    { src: "/_assets/485170711-1308137817341082-5036954073090041011-n.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/471191501-1114845036682617-6842805619149679997-n.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/487299722-1317946333026897-8302200838072951330-n.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/289542062-562295725270887-1557145661797255469-n.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/komphegn12.jpeg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-1000002638.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-1000002945.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-1000003382.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-1000003710.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-img20241015151231.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-img20231222124518.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/6043-1.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/6058.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/img20250930153748-1.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-1000003382_cf7c28b2.jpg", category: "Komposithegn", title: "Komposithegn" },
    { src: "/_assets/thumbnail-img20250717075857.jpg", category: "Komposithegn", title: "Komposithegn" },
  ];

  const categories = [
    'Alle',
    'Industrihegn',
    'Dobbeltporte',
    'Terrasser',
    'Komposithegn',
    'Panelhegn',
    'Smedejernshegn',
    'Betonhegn',
    'Træbeklædt hegn',
    'Kompositlåge',
    'Smedejernslåge',
    'Panellåge',
    'Rionetlåge',
    'Træbeklædte låger',
    'Skydeporte',
    'Foldeporte',
    'Carport',
    'Skur',
    'Rionet',
    'Vinduespartier',
  ];

  const filteredItems = activeCategory === 'Alle'
    ? referenceItems
    : referenceItems.filter((item) => item.category.toLowerCase() === activeCategory.toLowerCase());

  return (
    <>
      <SEO
        title="Referencer | Hovendals"
        description="Se vores store galleri over udførte hegn, porte, carporte, skure og låger. 100% kvalitetshåndværk i hele Danmark."
        ogImage="/_assets/485170711-1308137817341082-5036954073090041011-n-6.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={imageUrl("/_assets/485170711-1308137817341082-5036954073090041011-n-6.jpg", "width=1600,quality=80,format=auto")}
            alt="Referencer"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-images" aria-hidden="true"></i>
              <span>Billedgalleri</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Referencer
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Udforsk vores arbejde med hegn, porte, carporte og låger. Vælg en kategori herunder eller klik på et billede for at se det i fuld størrelse.
            </p>
          </div>
        </div>
      </section>

      {/* Filter and Gallery */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Categories Pill Bar */}
          <div className="flex flex-wrap items-center gap-2 mb-10 pb-6 border-b border-slate-100">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                onClick={() => setActiveCategory(cat)}
                className={`px-3.5 py-1.5 rounded-full text-xs font-bold transition-all ${
                  activeCategory === cat
                    ? 'bg-[#004FA4] text-white shadow-sm'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200 hover:text-slate-900'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="text-sm text-slate-500 mb-6">
            Viser {filteredItems.length} billeder {activeCategory !== 'Alle' && `i kategorien "${activeCategory}"`}
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {filteredItems.map((item, idx) => (
              <div
                key={idx}
                onClick={() => setLightboxIndex(idx)}
                className="group relative h-48 sm:h-56 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
              >
                <img
                  src={imageUrl(item.src, "width=400,quality=80,format=auto")}
                  alt={item.title || item.category}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-end p-3 text-white">
                  <span className="text-[11px] font-semibold text-[#c2ccdf] uppercase tracking-wider">
                    {item.category}
                  </span>
                  <span className="text-xs font-bold truncate">
                    {item.title}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox Modal */}
      <LightboxModal
        images={filteredItems}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
